export default function MySQL_SYLLABUS() {
  return (
    <div>
      <h2>MySQL_SYLLABUS</h2>    </div>
  );
}